import React, { useEffect, useState } from 'react'
import { ArrowUp } from 'lucide-react'

const ScrollToTopButton = ({ threshold = 1000 }: { threshold?: number }) => {
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      if (scrollY < threshold) {
        setShowButton(false)
      } else {
        setShowButton(true)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [threshold])

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return showButton ? (
    <button
      onClick={handleScrollToTop}
      className="fixed bottom-4 right-4 z-50 cursor-pointer rounded-lg bg-blue-600 p-2"
    >
      <ArrowUp size={36} className="text-white" />
    </button>
  ) : null
}

export default ScrollToTopButton
